import { useCallback, useState } from 'react';
import _ from 'lodash';
import { FIELDS, SMTP_FIELDS } from '../utils/constants';

const createInitialUpdatedData = integration => ({
    name: integration.name,
    login: integration.login,
    shopCountry: integration.shopCountry,
    shopRegion: integration.shopRegion,
    shopBaseApiUrl: integration.shopBaseApiUrl,
    marketplaceOrdersLastSync: integration.marketplaceOrdersLastSync,
    marketplaceMessagesLastSync: integration.marketplaceMessagesLastSync,
    restrictBlock: integration.restrictBlock,
    isExceededLimitBlocked: integration.isExceededLimitBlocked,
    password: integration.password,
    [SMTP_FIELDS.smtpServer]: integration[SMTP_FIELDS.smtpServer],
    [SMTP_FIELDS.smtpUseSsl]: integration[SMTP_FIELDS.smtpUseSsl],
    [SMTP_FIELDS.protocolType]: integration[SMTP_FIELDS.protocolType],
    [SMTP_FIELDS.protocolAddress]: integration[SMTP_FIELDS.protocolAddress],
    [SMTP_FIELDS.protocolPort]: integration[SMTP_FIELDS.protocolPort],
    [SMTP_FIELDS.protocolUseSsl]: integration[SMTP_FIELDS.protocolUseSsl]
});

/**
 * Maintains editable integration data and preserves the existing update payload semantics.
 *
 * @param {object} integration
 * @param {string} companyId
 */
export const useIntegrationDetailsForm = (integration, companyId) => {
    const [updatedData, setUpdatedData] = useState(() => createInitialUpdatedData(integration));

    const onChangeProperty = useCallback(property => value => {
        setUpdatedData(previousData => ({
            ...previousData,
            [property]: value
        }));
    }, []);

    const hasChanges = useCallback(fieldNames => {
        const notEmptyStringFields = [FIELDS.name, FIELDS.login];

        return fieldNames.some(key => {
            if (!Object.prototype.hasOwnProperty.call(updatedData, key)) return false;

            return (
                (
                    notEmptyStringFields.includes(key) &&
                    updatedData[key] &&
                    updatedData[key].trim().length &&
                    integration[key] !== updatedData[key]
                ) || updatedData[key] !== integration[key]
            );
        });
    }, [integration, updatedData]);

    const getUpdatePayload = useCallback(fieldNames => ({
        companyId,
        ...integration,
        ..._.pick(updatedData, fieldNames)
    }), [companyId, integration, updatedData]);

    return {
        getUpdatePayload,
        hasChanges,
        onChangeProperty,
        updatedData
    };
};
